import styled from 'styled-components';

export const PageNotFoundContainer = styled.div`
    text-align: center;
    margin-bottom: 100px;
`;

export const Title = styled.h1`
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 48px;
    line-height: 72px;
    color: #0e4574;
    margin-top: 100px;
`;

export const Subtitle = styled.h2`
    font-family: 'Poppins';
    font-size: 20px;
    font-weight: 600;
    line-height: 35px;
    color: #4f7fa7;
    margin-bottom: 20px;
`;
